/* JUGO Shop All v2 — light interactive layer.
   - Sub/one-time toggle on product cards
   - Card "Subscribe" / "Add to cart" submission via /cart/add.js
   - Carousel arrow scroll
   - FAQ accordion + category filter */
(function () {
  'use strict';
  var ROOT = document.querySelector('.jugo-shop-all-v2');
  if (!ROOT) return;

  // Pricing display strategy: we DO NOT bake WELCOME20 into the displayed price.
  // WELCOME20 auto-applies at checkout for first-time customers as a surprise discount.
  // Subscribe toggle simply flips between full retail (one-time) and subscribe ongoing (15% off).
  var SUB_DISCOUNT = 0.15;

  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || ROOT).querySelectorAll(sel)); }

  function toggleSub(btn) {
    var tile = btn.closest('.card-tile');
    if (!tile) return;
    var priceEl = tile.querySelector('.card-price');
    var ctaBtn = tile.querySelector('.card-cta');
    var isOn = btn.getAttribute('data-on') === '1';
    var retailStr = priceEl.getAttribute('data-one');
    var retail = parseFloat(retailStr);
    if (!isFinite(retail)) return;
    var amt = priceEl.querySelector('.price-amt');
    var renewal = priceEl.querySelector('.price-renewal');
    if (isOn) {
      btn.setAttribute('data-on', '0');
      if (amt) amt.textContent = '$' + retail.toFixed(2);
      if (renewal) renewal.style.display = 'none';
      if (ctaBtn) { ctaBtn.textContent = 'Add to cart'; ctaBtn.classList.add('is-once'); }
    } else {
      btn.setAttribute('data-on', '1');
      if (amt) amt.textContent = '$' + (retail * (1 - SUB_DISCOUNT)).toFixed(2);
      if (renewal) renewal.style.display = '';
      if (ctaBtn) { ctaBtn.textContent = 'Subscribe'; ctaBtn.classList.remove('is-once'); }
    }
  }

  function toggleFaq(btn) {
    var item = btn.closest('.faq-item');
    if (item) item.classList.toggle('open');
  }

  function filterFaq(chip) {
    var cat = chip.dataset.cat;
    $all('.faq-chip').forEach(function (c) { c.classList.toggle('is-active', c === chip); });
    $all('.faq-item').forEach(function (item) {
      item.style.display = (cat === 'all' || item.dataset.cat === cat) ? '' : 'none';
    });
  }

  function carouselScroll(btn, dir) {
    var car = btn.closest('.carousel');
    if (!car) return;
    var track = car.querySelector('.carousel-track');
    if (!track) return;
    var first = track.firstElementChild;
    if (!first) return;
    var step = first.getBoundingClientRect().width + 14;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  }

  function updateCarouselArrows() {
    $all('.carousel').forEach(function (car) {
      var track = car.querySelector('.carousel-track');
      if (!track) return;
      var overflowing = track.scrollWidth > track.clientWidth + 4;
      car.classList.toggle('has-overflow', overflowing);
    });
  }

  function addCardToCart(card) {
    var variantId = card.getAttribute('data-variant-id');
    if (!variantId) {
      var url = card.getAttribute('data-product-url');
      if (url) window.location.href = url;
      return;
    }
    var subBtn = card.querySelector('.sub-toggle');
    var isSubscribing = subBtn ? subBtn.getAttribute('data-on') === '1' : false;
    var sellingPlanId = card.getAttribute('data-selling-plan-id');
    var item = { id: parseInt(variantId, 10), quantity: 1 };
    if (isSubscribing && sellingPlanId) item.selling_plan = parseInt(sellingPlanId, 10);
    var cta = card.querySelector('.card-cta');
    if (cta) { cta.disabled = true; cta.dataset.prevText = cta.textContent; cta.textContent = 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [item] })
    }).then(function (r) {
      if (!r.ok) throw new Error('cart/add failed: ' + r.status);
      return r.json();
    }).then(function () {
      // Desktop: the twmp-cart-drawer controller patches fetch, intercepts this
      // /cart/add and re-renders + opens the slide-out drawer — so DON'T navigate
      // (navigating to /cart is what caused the full-page flash + bounce).
      // Mobile: no drawer interception, so go to the native cart page.
      var isDesktop = window.matchMedia('(min-width: 990px)').matches;
      if (isDesktop) {
        if (cta) { cta.disabled = false; cta.textContent = 'Added ✓'; setTimeout(function () { cta.textContent = cta.dataset.prevText || 'Subscribe'; }, 2000); }
      } else {
        window.location.href = '/cart';
      }
    })
      .catch(function (err) {
        console.error('[JUGO Shop All] Add to cart failed:', err);
        if (cta) { cta.disabled = false; cta.textContent = cta.dataset.prevText || 'Add to cart'; }
        alert("Couldn't add to your cart. Please try again.");
      });
  }

  function init() {
    $all('.sub-toggle').forEach(function (btn) {
      btn.addEventListener('click', function () { toggleSub(btn); });
    });
    $all('.faq-q').forEach(function (btn) {
      btn.addEventListener('click', function () { toggleFaq(btn); });
    });
    $all('.faq-chip').forEach(function (chip) {
      chip.addEventListener('click', function () { filterFaq(chip); });
    });
    $all('.carousel-arrow').forEach(function (btn) {
      var dir = parseInt(btn.getAttribute('data-dir') || '1', 10);
      btn.addEventListener('click', function () { carouselScroll(btn, dir); });
    });
    $all('.card-cta').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        var card = btn.closest('.card-product');
        if (!card) return;
        if (card.hasAttribute('data-variant-id') && card.getAttribute('data-variant-id') !== '') {
          e.preventDefault();
          addCardToCart(card);
        }
      });
    });

    updateCarouselArrows();
    var rafId = null;
    window.addEventListener('resize', function () {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(updateCarouselArrows);
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(updateCarouselArrows);
    }
    window.addEventListener('load', updateCarouselArrows);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
